import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../../components/Preloader";

export default function AdminPortfolioList() {

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://apnaqwebx-mern.onrender.com/api/portfolio")
      .then(res => setProjects(res.data), setLoading(false)) 
      .catch(err => console.log(err));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    await axios.delete(`https://apnaqwebx-mern.onrender.com/api/portfolio/${id}`);

    setProjects(projects.filter((p) => p._id !== id));
  };

  return (
    <div className="p-4 md:p-8 md:pt-28 pt-44">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-[#855109]">Portfolio Projects</h1>

        <Link
          to="/admin/add-portfolio"
          className="px-5 py-2 bg-[#855109] text-white rounded-lg shadow hover:bg-[#6d4108] transition font-semibold"
        >
          + Add New Project
        </Link>
      </div>

       {/* LOADING */}
        {loading && (
          // <p className="text-center mt-10 text-[#855109]">Our Portfolio Loading...</p>
          <Preloader />
        )}

      {/* GRID */}
      <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
        {projects.map((project) => (
          <div key={project._id} className="bg-white shadow-lg rounded-xl p-4 border border-[#e6dccc]">

            <a href={project.url} target="_blank" rel="noreferrer">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-40 object-cover rounded-lg mb-4"
              />

              <h2 className="text-lg text-center font-bold text-[#855109]">
                {project.title}
              </h2>
            </a>

            {/* BUTTONS */}
            <div className="flex justify-end gap-3 mt-4">
              <Link
                to={`/admin/edit-portfolio/${project._id}`}
                className="px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
              >
                Edit
              </Link>

              <button
                onClick={() => handleDelete(project._id)}
                className="px-3 py-1 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
              >
                Delete
              </button>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
}
